/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { ToastProps } from '../../components/Toast/Toast/Toast';

export const toastSlice = createSlice({
  name: 'toasts',
  initialState: [] as ToastProps[],
  reducers: {
    addToast: (state, action) => {
      state.push(action.payload);
    },
    removeToast: (state, action: { payload: { id: string } }) => {
      const index = state.findIndex((s) => s.id === action.payload.id);
      state.splice(index, 1);
    },
  },
});

export const { addToast, removeToast } = toastSlice.actions;

export default toastSlice.reducer;
